import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsLoading, selectSmartMenu } from '../redux/selectors';
import { fetchUsers } from '../redux/actions';
import { Header, Smart} from '../components';
import Loading from '../components/loading';
import MessagePortal from '../components/portal';
import User from '../components/user';

const Layout = ({children}) => {

  const dispatch = useDispatch()

  const loading = useSelector(selectIsLoading);
  const smartMenu = useSelector(selectSmartMenu);

  useEffect(()=>{
    dispatch(fetchUsers())
  },[children])

  return (
    <main>
      <Loading
        loading={loading}
      />
      <MessagePortal />
      <Header />
      <Smart
        smartMenu={smartMenu}
      />
      <User />
      {children}
    </main>
  );
}

export default Layout;